import { Shield, Stethoscope, Lock } from 'lucide-react';

const signals = [
  { icon: Shield, label: 'HIPAA-Hardened' },
  { icon: Stethoscope, label: 'Surgeon-Verified' },
  { icon: Lock, label: 'Enterprise Healthcare' },
];

export function TrustBar() {
  return (
    <section className="py-14 md:py-20 border-t border-border bg-background">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-medium mb-8">
          Built for Enterprise Healthcare. HIPAA-Hardened. Surgeon-Verified.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
          {signals.map((s) => (
            <div
              key={s.label}
              className="flex items-center gap-3 px-5 py-3 rounded-xl border border-border bg-card"
            >
              <s.icon className="h-5 w-5 text-primary" strokeWidth={1.5} />
              <span className="text-sm font-semibold text-foreground tracking-tight">
                {s.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
